module.exports = __webpack_public_path__ + "img/3.2f820e92.jpg";